import { createContext } from 'react';

interface DocumentContext {
	document?: Document;
}

export const DocumentContext = createContext<DocumentContext>({});
